// extracted by mini-css-extract-plugin
export var indeterminate = "_1e-5";
export var md = "_1e-4";
export var semantic = "_1e-6";
export var sm = "_1e-3";
export var text = "_1e-7";
export var toggleInput = "_1e-0";
export var toggleSwitch = "_1e-1";
export var xs = "_1e-2";